// 添加管理员(仅族长)
export function addAdmin(data) {
  return request({
    url: '/huaxi/app/api/guild/addAdmin/v1_0_0',
    method: 'post',
    data: data
  })
}
// 删除管理员(仅族长)
export function delAdmin(data) {
  return request({
    url: '/huaxi/app/api/guild/delAdmin/v1_0_0',
    method: 'post',
    data: data
  })
}
// 删除家族成员(仅族长)
export function delMember(data) {
  return request({
    url: '/huaxi/app/api/guild/delMember/v1_0_0',
    method: 'post',
    data: data
  })
}
// 获取家族管理员列表
export function getGuildAdminList(query) {
  return request({
    url: '/huaxi/app/api/guild/getGuildAdminList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取家族申请列表(仅族长调用,管理员调用)
export function getGuildApplyList(query) {
  return request({
    url: '/huaxi/app/api/guild/getGuildApplyList/v1_0_0',
    method: 'get',
    params: query
  })
}
import request from '@/utils/request'
// 获取家族房间列表(查所有状态)
export function getGuildChatRoomList(query) {
  return request({
    url: '/huaxi/app/api/guild/getGuildChatRoomList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取家族房间统计详情(族长调用)
export function getGuildChatRoomStatisticsInfo(query) {
  return request({
    url: '/huaxi/app/api/guild/getGuildChatRoomStatisticsInfo/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取家族成员列表
export function getGuildMemberList(query) {
  return request({
    url: '/huaxi/app/api/guild/getGuildMemberList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取家族退会记录(仅族长调用)
export function getGuildReturnRecordsList(query) {
  return request({
    url: '/huaxi/app/api/guild/getGuildReturnRecordsList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取家族营收数据(仅族长调用)
export function getGuildRevenueStatisticsInfo(query) {
  return request({
    url: '/huaxi/app/api/guild/getGuildRevenueStatisticsInfo/v1_0_0',
    method: 'get',
    params: query
  })
}
// 处理入会申请(仅族长,管理员调用)
export function handleJoinApply(data) {
  return request({
    url: '/huaxi/app/api/guild/handleJoinApply/v1_0_0',
    method: 'post',
    data: data
  })
}
// 处理退会申请(status=0并且族长调用)
export function handleReturnApply(data) {
  return request({
    url: '/huaxi/app/api/guild/handleReturnApply/v1_0_0',
    method: 'post',
    data: data
  })
}
// 获取家族成员统计信息(仅族长调用)
export function getGuildMemberStatisticsInfo(query) {
  return request({
    url: '/huaxi/app/api/guild/getGuildMemberStatisticsInfo/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取我的家族详情
export function getMyGuildInfo(query) {
  return request({
    url: '/huaxi/app/api/guild/getMyGuildInfo/v1_0_0',
    method: 'get',
    params: query
  })
}
// 修改家族信息
export function updateGuildInfo(data) {
  return request({
    url: '/huaxi/app/api/guild/updateGuildInfo/v1_0_0',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/gonghui.js